import { getGroup } from "./utilsV2";

export const GROUPS = ["Left", "G", "S&D", "RE", "EPP", "ECR", "PfE", "ESN", "NI"];

export const setParents = (stats: CountryStat[]) => {
    stats.filter(x => x.DataType === 'region').forEach(x => x.Parent = stats.find(y => y.Country === x.Country && y.DataType === 'country'));
}

let wasModified = false;
const convertSeatToPerc = (stats: CountryStat[]) => {
    if (!wasModified && !stats["wasModified"]) {
        wasModified = true;
        stats.filter(x => ["Netherland", "Belgium"].includes(x.Country))
            .forEach(x => x.Polls.forEach(poll => poll.Values.forEach((v, i) => poll.Values[i] = Math.round(v * 7.5)/10)));
        stats["wasModified"] = true;
    }
}

let wasModifiedCoalition = false;
const updateCoalitionToParty = (stats: CountryStat[], countries: CountryData[]) => {
    if (wasModifiedCoalition) { return; }
    wasModifiedCoalition = true;

    // This code copies data from coalition (party) into main party of the coalition as if the coalition and main party was the same entity
    stats.forEach(x => {
        const country = countries.find(y => y.Country === x.Country);
        country?.PartyData.filter(y => y.CoalitionOf && y.CoalitionOf.length > 0).forEach(partyData => {
            if (partyData.CoalitionOf) {
                const mainParty = partyData.CoalitionOf[0];
                const indexOfMainParty = x.Parties.indexOf(mainParty);
                const indexOfCoalition = x.Parties.indexOf(partyData.Party);
                if (indexOfMainParty > -1 && indexOfCoalition > -1) {
                    x.Polls.forEach(poll => {
                        poll.Values[indexOfMainParty] += poll.Values[indexOfCoalition] ?? 0;
                    });
                }
            }
        })
    });
}

export const fixCountryStats = (stats: CountryStat[], countries: CountryData[]) => {
    // Set parent country for regions
    setParents(stats);

    // Convert seats count to percentage on polls
    convertSeatToPerc(stats);

    // Update coalition to main party as if the coalition data was used for the main party
    updateCoalitionToParty(stats, countries);
}

export const getCountryStat = (stats: CountryStat[], countryRegion: string): CountryStat | undefined => {
    //fixCountryStats(stats);

    return stats.find(x => x.Region === countryRegion || (x.Country === countryRegion && x.DataType === 'country'));
}

export const getColorByGroup = (group: string): string => {
    switch (group) {
      case 'Left': return '#a00';
      case 'G': return '#4a4';
      case 'S&D': return '#f00';
      case 'RE': return '#990';
      case 'EPP': return '#38f';
      case 'ECR': return '#00f';
      case 'PfE': return '#009';
      case 'ESN': return '#338';
      case 'NI': return '#999';
      default: return '#fff';
    }
  }
  export const getColorByGroup2 = (group: string): string => {
    switch (group) {
      case 'Left': return '#a66';
      case 'G': return '#9f9';
      case 'S&D': return '#f88';
      case 'RE': return '#cc3';
      case 'EPP': return '#8ef';
      case 'ECR': return '#88f';
      case 'ESN':
      case 'PfE': return '#669';
      case 'NI': return '#ccc';
      default: return '#fff';
    }
  }
  export const getColorByGroup3 = (group: string): string => {
    switch (group) {
      case 'Left': return '#d99';
      case 'G': return '#bfb';
      case 'S&D': return '#fcc';
      case 'RE': return '#ffa';
      case 'EPP': return '#bff';
      case 'ECR': return '#aaf';
      case 'ESN':
      case 'PfE': return '#99a';
      case 'NI': return '#eee';
      default: return '#fff';
    }
  }

  export const styleByGroup = (group: string): string => {
    switch (group) {
        case "Left": return "groupLeft";
        case "G": return "groupG";
        case "S&D": return "groupSD";
        case "RE": return "groupRe";
        case "EPP": return "groupEpp";
        case "ECR": return "groupEcr";
        case "PfE": return "groupId";
        case 'ESN': return "groupEsn";
        case "NI":
        default: return "groupNi";
    }
}
export const getLightColorByGroup = (group: string): string => {
    switch (group) {
        case "Left": return "#a66";
        case "G": return "#9f9";
        case "S&D": return "#f88";
        case "RE": return "#ff6";
        case "EPP": return "#8ef";
        case "ECR": return "#88f";
        case 'ESN':
        case "PfE": return "#669";
        case "NI":
        default: return "#ccc";
    } 
}


export const getColorByLikelihood = (likelihood: number): string => {
    const colors = ["#777", "#555", "#444", "#f66", "#f11"];
    if (likelihood >= 90) {
        return colors[0];
    } else if (likelihood >= 55) {
        return colors[1];
    } else if (likelihood >= 40) {
        return colors[2];
    } else {
        return colors[3];
    }
}
export const getTextByLikelihood = (likelihood: number): string => {
    const texts = ["very likely", "likely", "probable", "not much likely"];
    if (likelihood >= 90) {
        return texts[0];
    } else if (likelihood >= 55) {
        return texts[1];
    } else if (likelihood >= 40) {
        return texts[2];
    } else {
        return texts[3];
    }
}



export const getColorByLeftRightScore = (score: number): string => {
    const colors = ["#900", "#a11", "#c22", "#e44", "#f77", "#ddd", "#77f", "#44e", "#22c", "#11a", "#009"];
    if (score > 50) {
        return colors[0];
    } else if (score > 30) {
        return colors[1];
    } else if (score > 10) {
        return colors[2];
    } else if (score > 5) {
        return colors[3]
    } else if (score > 1) {
        return colors[4];
    } else if (score > -1) {
        return colors[5];
    } else if (score > -5) {
        return colors[6];
    } else if (score > -10) {
        return colors[7];
    } else if (score > -30) {
        return colors[8];
    } else if (score > -50) {
        return colors[9];
    } else {
        return colors[10];
    }
}
export const getColorByLibConScore = (score: number): string => {
    const colors = ["#990", "#aa1", "#cc2", "#ee4", "#ff7", "#ddd", "#8ff", "#7ef", "#6df", "#4cf", "#2bf"];
    if (score > 50) {
        return colors[0];
    } else if (score > 30) {
        return colors[1];
    } else if (score > 10) {
        return colors[2];
    } else if (score > 5) {
        return colors[3]
    } else if (score > 1) {
        return colors[4];
    } else if (score > -1) {
        return colors[5];
    } else if (score > -5) {
        return colors[6];
    } else if (score > -10) {
        return colors[7];
    } else if (score > -30) {
        return colors[8];
    } else if (score > -50) {
        return colors[9];
    } else {
        return colors[10];
    }
}
export const getGrayColorByScore = (score: number): string | null => {
    const colors = ["#fff", "#eee", "#ddd", "#ccc", "#bbb", "#aaa", "#999", "#888", "#666", "#444"];
    for (let i = 0; i < colors.length; ++i) {
        if (score > 90 - 10 * i) {
            return colors[i];
        }
    }
    return null;
}

export const getColorByGroupScore = (group: string, score: number): string | null => {
    let index = -1;
    if (score >= 40) { index = 0 }
    else if (score >= 30) { index = 1; }
    else if (score >= 20) { index = 2; }
    else if (score >= 10) { index = 3; }
    else if (score >= 5) { index = 4; }
    else if (score > 0) { index = 5; }
    switch (group) {
        case "Left": return index === -1 ? null : ["#600", "#800", "#c00", "#f00", "#f33", "#f55"][index];
        case "G": return ["#171", "#393", "#5b5", "#7d7", "#9e9", "#bfb"][index];
        case "S&D": return ["#f00", "#f11", "#f33", "#f55", "#f77", "#f99"][index];
        case "RE": return ["#990", "#aa1", "#cc3", "#dd4", "#ee5", "#ff8"][index];
        case "EPP": return ["#2bf", "#4cf", "#6df", "#7ef", "#aff", "#cff"][index];
        case "ECR": return ["#00f", "#22f", "#44f", "#66f", "#88f", "#aaf"][index];
        case 'ESN':
        case "PfE": return ["#007", "#11a", "#33b", "#55c", "#77d", "#99f"][index];
        case "NI":
        default: return ["#888", "#999", "#aaa", "#bbb", "#ccc", "#ddd"][index];
    } 
}

const sumByGroup = (groups: string[], partyValues: PartyValue[]) => {
    return partyValues.reduce((s, a) => (groups.includes(a.group) ? a.value : 0) + s, 0);
}

export const leftRightScore = (prediction: PartyValue[]): number => {
    const left = sumByGroup(["Left", "G", "S&D"], prediction);
    const right = sumByGroup(["EPP", "ECR", "PfE", "ESN"], prediction);
    return Math.round((left - right) * 10)/10;
}
export const libConScore = (prediction: PartyValue[]): number => {
    const lib = sumByGroup(["Left", "G", "S&D", "RE"], prediction);
    const con = sumByGroup(["EPP", "ECR", "PfE", "ESN"], prediction);
    return Math.round((lib - con) * 10)/10;
}

export const getLastElection = (countryStat: CountryStat): ElectionData => {
    return countryStat.Elections[0];
}
export const getPrevElection = (countryStat: CountryStat): ElectionData | null => {
    return countryStat.Elections.length > 1 ? countryStat.Elections[1] : null;
}
export const getCurrentGovernment = (countryStat: CountryStat): GovernmentData => {
    return countryStat.Governments[0];
}

export const getPollValues = (countryStat: CountryStat, poll: IValues): PartyValue[] => {
    return poll.Values.map((x, i) => { 
        const party = countryStat.Parties[i];
        return { party, group: getGroup(countryStat, party), value: x } as PartyValue;
    });
}

export const DHondt = (votes: number[], seatCount: number, threshold: number): number[] => {
    const seats = votes.map(x => { return 0; });

    for (let j = 0; j < seatCount; ++j) {
        const newVotes = votes.map((x, i) => x >= threshold ? 10000 * x / (seats[i] + 1) : 0);
        const max = Math.max(...newVotes);
        const maxIndex = newVotes.indexOf(max);
        seats[maxIndex] += 1;
    }
    return seats;
}
